<!-- 审批记录时间线（待审批 / 我审批 两个列表共用） -->
<template>
  <div class="ps-record-pop" @click.stop>
    <div class="ps-record-pop-title">审批记录</div>
    <div v-if="loading" class="ps-record-empty">加载中…</div>
    <div v-else-if="records && records.length" class="ps-timeline">
      <div v-for="(rec, ri) in records" :key="ri" class="ps-tl-item">
        <span class="ps-tl-dot" :style="{ background: recordColor(rec.action) }" />
        <div class="ps-tl-body">
          <div class="ps-tl-head">
            <span class="ps-tl-action" :style="{ color: recordColor(rec.action) }">{{ recordLabel(rec.action) }}</span>
            <span class="ps-tl-operator">{{ rec.operator }}</span>
            <span class="ps-tl-time">{{ rec.time }}</span>
          </div>
          <div v-if="rec.comment" class="ps-tl-comment">{{ rec.comment }}</div>
        </div>
      </div>
    </div>
    <div v-else class="ps-record-empty">暂无审批记录</div>
  </div>
</template>

<script setup>
defineProps({
  records: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

/** 审批动作 → 文案 */
const ACTION_MAP = {
  submit: { label: '提交申请', color: '#2655f1' },
  approve: { label: '审批通过', color: '#1FC76B' },
  reject: { label: '已驳回', color: '#FF8A1E' },
}

const recordLabel = (action) => ACTION_MAP[action]?.label || action
const recordColor = (action) => ACTION_MAP[action]?.color || '#2655f1'
</script>

<style scoped>
.ps-record-pop {
  min-width: 280px;
  max-width: 380px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  padding: 14px 16px;
}

.ps-record-pop-title {
  font-size: 14px;
  font-weight: 600;
  color: #2e2e2e;
  margin-bottom: 12px;
}

/* 时间线 */
.ps-timeline {
  position: relative;
}

.ps-tl-item {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 16px;
}

.ps-tl-item:last-child {
  padding-bottom: 0;
}

/* 节点之间的竖线 */
.ps-tl-item:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 14px;
  bottom: 0;
  width: 2px;
  background: rgba(0, 0, 0, 0.08);
}

.ps-tl-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 4px;
  z-index: 1;
}

.ps-tl-body {
  flex: 1;
  min-width: 0;
}

.ps-tl-head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ps-tl-action {
  font-size: 13px;
  font-weight: 600;
}

.ps-tl-operator {
  font-size: 13px;
  color: #2e2e2e;
}

.ps-tl-time {
  font-size: 12px;
  color: rgba(46, 46, 46, 0.45);
  margin-left: auto;
}

.ps-tl-comment {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.6;
  color: rgba(46, 46, 46, 0.75);
}

.ps-record-empty {
  font-size: 13px;
  color: rgba(46, 46, 46, 0.45);
}
</style>
